export default __webpack_public_path__ + "static/image-51-9ccbc8e3ad235ec7449adaeb59468efe.jpg";